export const OrderByTasks = [
  {
    value: 'last_update',
    label: 'Ultimas Atualizações',
  },
  {
    value: 'urgent',
    label: 'Urgentes',
  },
  {
    value: 'oldest_created',
    label: 'Antigos Primeiro',
  },
  {
    value: 'last_created',
    label: 'Mais Recentes Primeiro',
  },
  {
    value: 'less_quotes',
    label: 'Menos Orçamentos Primeiro',
  },
  {
    value: 'more_quotes',
    label: 'Mais Orçamentos Primeiro',
  },
  {
    value: 'oldest_hired',
    label: 'Mais tempo contratado',
  },
  {
    value: 'oldest_charged',
    label: 'Mais tempo de serviço executado',
  },
  {
    value: 'higher_price',
    label: 'Valor maior primeiro',
  },
  {
    value: 'lower_price',
    label: 'Valor menor primeiro',
  },
];

export const OptionsFilterResponsibily = [
  {
    value: '',
    label: 'Todos',
  },
  {
    value: '3',
    label: 'Inquilino',
  },
  {
    value: '2',
    label: 'Proprietário',
  },
];

export const OptionsNumOrder = [
  {
    value: '',
    label: 'Todos',
  },
  {
    value: '0',
    label: 'Sem orçamentos',
  },
  {
    value: '1',
    label: '1',
  },
  {
    value: '2',
    label: '2',
  },
  {
    value: '3',
    label: '3 ou mais',
  },
];

export const OptionsOpenTime = [
  {
    value: '',
    label: 'Todos',
  },
  {
    value: '0,24',
    label: 'Até 1 dia',
  },
  {
    value: '24,48',
    label: 'De 1 á 2 dias',
  },
  {
    value: '48,72',
    label: 'De 2 á 3 dias',
  },
  {
    value: '72,0',
    label: 'Mais de 3 dias',
  },
];

export const OptionLocal = {
  url: 'addresses',
  name: 'address_id',
  value: 'id',
  label: 'address',
  isAutoComplete: true,
};

// export const filters = [
//   {
//     placeholder: 'Local',
//     url: 'addresses',
//     name: 'address_id',
//     value: 'id',
//     label: 'address',
//     isAutoComplete: true,
//   },
//   {
//     placeholder: 'Origem',
//     url: 'source',
//     name: 'source',
//     value: 'id',
//     label: 'name',
//     isAutoComplete: false,
//   },
//   {
//     placeholder: 'Status',
//     url: 'services',
//     name: 'status',
//     value: 'status_id',
//     label: 'name',
//     isAutoComplete: false,
//   },
//   // {
//   //   placeholder: 'Número de orçamentos',
//   //   name: 'quotes',
//   //   value: 'value',
//   //   label: 'label',
//   //   isAutoComplete: false,
//   // },
//   {
//     placeholder: 'Tipo de serviço',
//     url: 'services',
//     name: 'service_id',
//     value: 'id',
//     label: 'text',
//     isAutoComplete: true,
//   },
//   // {
//   //   placeholder: 'Mensagens',
//   //   name: 'unread_messages',
//   //   value: 'unread_messages',
//   //   getValue: () => 1,
//   //   label: null,
//   //   getLabel: () => 'Mensagem não lida',
//   //   isAutoComplete: false,
//   // },
//   {
//     placeholder: 'Analista',
//     url: 'users',
//     name: 'user_id',
//     value: 'id',
//     label: 'name',
//     isAutoComplete: true,
//   },
//   {
//     placeholder: 'Responsabilidade',
//     url: 'responsibility-roles?show_select=true',
//     name: 'responsibility_id',
//   },
// ];
